import { render, staticRenderFns } from "./ReportSurgery.vue?vue&type=template&id=4f1f2464&scoped=true"
import script from "./ReportSurgery.vue?vue&type=script&lang=js"
export * from "./ReportSurgery.vue?vue&type=script&lang=js"
import style0 from "./ReportSurgery.vue?vue&type=style&index=0&id=4f1f2464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1f2464",
  null
  
)

export default component.exports